<nz-result [nzStatus]="'success'" [nzTitle]="documentTitle + ' successfully placed' | locale"
  [nzSubTitle]="('Thank you for placing ' + documentTitle + ', document number: ' | locale) + DocNum">
  <div nz-result-content *ngIf="extraMessage !== ''">
    <div class="desc">
      <h4 nz-title>{{extraMessage}}</h4>
    </div>
  </div>
  <div nz-result-extra>
    <button nz-button nzType="default" [nzSize]="'large'" nzShape="round" (click)="goToShoppingCart()">
      {{'Continue shopping' | locale}}
    </button>
  </div>
</nz-result>
